import type { Module } from "@webmotors/ioc";
import { ConfigFactory } from "./config.factory";
import { CONFIG, EnvironmentType } from "./config.types";

export function createConfigModule(
  environmentType: EnvironmentType = EnvironmentType.LOCAL
): Module {
  return {
    name: "ConfigModule",
    providers: [
      {
        name: CONFIG,
        useFactory: () => {
          return ConfigFactory(environmentType);
        },
      },
    ],
  };
}
